module.exports = __webpack_public_path__ + "img/mcu.414eda5e.svg";